import React, { useEffect } from "react";
import { useKeycloak } from "@react-keycloak/web";
import {
  clearKeycolakToken,
  setKeycloakToken,
} from "src/helpers/keycloak.helper";

const AuthProvider = ({ children }) => {
  const { keycloak, initialized } = useKeycloak();

  useEffect(() => {
    if (initialized && keycloak) {
      console.log("Keycloak token:", keycloak.token);
      if (keycloak.authenticated && keycloak.token) {
        // Store the token in localStorage
        console.log("Token stored in localStorage");
        setKeycloakToken(keycloak.token);
      } else {
        //Remove token from localStorage
        console.log("Token removed from localStorage");
        clearKeycolakToken();
      }
    }
  }, [keycloak, initialized]);

  return children;
};

export default AuthProvider;
